import * as stylex from "@stylexjs/stylex";
import { colors, layoutAreas } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
const styles = {
    root: {
        kBCFzs: "x1uq3dmu",
        k1xSpc: "x78zum5",
        kGNEyG: "x6s0dn4",
        ks0D6T: "xosgda",
        kmVPX3: "x1ff1495",
        kWkggS: "x12peec7",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x12a9do8",
        kaIpWk: "x1cum3z5",
        kMwMTN: "x12klvby",
        kwh8RV: "xc22qbq",
        kDPRdz: "xhr9w20",
        kgeoSG: "x1xhnyyv",
        kP1sEF: "xpo3ry2",
        k5JduY: "xs5nyxy",
        kc3QkE: "x1azrkns",
        kb7pNg: "xn12031",
        $$css: true
    }
};
const foldVariant = (variant)=>({
        gem: new URL("../../assets/bg_logo_gem.svg", import.meta.url).href,
        sdg4: new URL("../../assets/bg_logo_sdg-4.svg", import.meta.url).href
    })[variant];
export const LinkBlock = ({ title, url, variant })=>{
    return <a href={url} {...stylex.props(typography.body2, styles.root)}>
      <img alt="" className="x100vrsf x1vqgdyp x4756gz" src={foldVariant(variant)}/>
      <span className="x1lliihq">{title}</span>
    </a>;
};
